import { createFileRoute } from '@tanstack/react-router';
import { HomePage } from '../../features/home/home-page.tsx';
import { guardSection } from '../../shell/guard.ts';

// Home (T24, spec F2). Attesters have no Home (spec §2) and land on Start here instead.
export const Route = createFileRoute('/_authed/')({
  beforeLoad: guardSection('/'),
  component: HomePage,
});
